$(window).on('load',function () {
	$('.map').each(function () {
		var self = this;
		ymaps.ready(function () {

			var id =  $(self).attr('id');
			var $idElement = $('#'+ id);

			var lat = $idElement.data('lat');
			var lng = $idElement.data('lng');

			if ($idElement.get(0)) {
				var myMap = new ymaps.Map(id, {
					center: [parseFloat(lat),parseFloat(lng)],
					zoom: 14
				}, {
					searchControlProvider: 'yandex#search'
				});
				var myPlacemark = new ymaps.Placemark(myMap.getCenter(), {}, {
					iconLayout: 'default#image',
					iconImageHref: __app.TEMPLATE_URI + 'images/marker.png',
					iconImageSize: [48, 48],
					iconImageOffset: [-24, -24]
				});
				myMap.geoObjects.add(myPlacemark);
			}
		});
	});
});
